import React, { useState } from 'react'
import {Helmet} from 'react-helmet';
import {Button} from 'aurorui';
import './style.css'
import { ComponentScreen } from '../component-screen';
import { PropsTable } from '../../components';




function ButtonScreen() {
  const [type, setType] = useState<"dark" | 'default' | 'secondary'>('secondary');
  const [roundedType, setRoundedType] = useState<"small" | 'medium' | 'large' | 'extralarge'>('extralarge');
  const [disabled,setDisabled] = useState<boolean>(false);
  const [size, setSize] = useState<"large" | "normal">("large");
  const [variant, setVariant] = useState<"outlined" | "filled">("filled")

  return (
    <div className=' screen red-bg'>
      <Helmet>
          <meta charSet="utf-8" />
          <title>AURORUI</title>
      </Helmet>
      <h1 className="component-name">Button</h1>

      <div className='display_grid'>
          <div className='variant'>
            <div className={`tab`}>Dark</div>
            <div className='component'>
              <Button
                  label='Press me'
                  onClick={()=>{}}
                  type={'dark'}
                  roundedType={roundedType}
                  disabled={disabled}
                  size={size}
                  variant={variant}
                  
              />
              <Button
                  label='Press me'
                  onClick={()=>{}}
                  type={'dark'}
                  roundedType={'small'}
                  disabled={false}
                  size={'normal'}
                  variant={'filled'}
                  
                  
              />
              <Button
                  label='Press me'
                  onClick={()=>{}}
                  type={'dark'}
                  roundedType={'large'}
                  disabled={false}
                  size={'large'}
                  variant={'filled'}
              />
              <Button
                  label='Press me'
                  onClick={()=>{}}
                  type={'dark'}
                  roundedType={'large'}
                  disabled={false}
                  size={'large'}
                  variant={'filled'}
                  loading
              />
          </div>
          </div>
          
          <div className='variant'>
            <div className={`tab`}>Default</div>
              <div className='component'>
                <Button
                    label='Press me'
                    onClick={()=>{}}
                    type={'default'}
                    roundedType={roundedType}
                    disabled={disabled}
                    size={size}
                    variant={variant}
                    
                />
                <Button
                    label='Press me'
                    onClick={()=>{}}
                    type={'default'}
                    roundedType={'small'}
                    disabled={false}
                    size={'normal'}
                    variant={'filled'}
                    
                    
                />
                <Button
                    label='Press me'
                    onClick={()=>{}}
                    type={'default'}
                    roundedType={'large'}
                    disabled={false}
                    size={'large'}
                    variant={'filled'}
                    
                />
                <Button
                    label='Press me'
                    onClick={()=>{}}
                    type={'default'}
                    roundedType={roundedType}
                    disabled={disabled}
                    size={size}
                    variant={variant}
                    loading
                />
            </div>
          </div>

          <div className='variant'>
            <div className={`tab`}>Secondary</div>
              <div className='component'>
                <Button
                    label='Press me'
                    onClick={()=>{}}
                    type={'secondary'}
                    roundedType={roundedType}
                    disabled={disabled}
                    size={size}
                    variant={variant}
                    
                />
                <Button
                    label='Press me'
                    onClick={()=>{}}
                    type={'secondary'}
                    roundedType={'small'}
                    disabled={false}
                    size={'normal'}
                    variant={'filled'}
                    
                    
                />
                <Button
                    label='Press me'
                    onClick={()=>{}}
                    type={'secondary'}
                    roundedType={'large'}
                    disabled={false}
                    size={'large'}
                    variant={'filled'}
                    
                />

                <Button
                    label='Press me'
                    onClick={()=>{}}
                    type={'secondary'}
                    roundedType={'medium'}
                    disabled={disabled}
                    size={'normal'}
                    variant={variant}
                    loading
                />
              </div>
          </div>
      </div>
      
      <div className='props-sec'>
        <h3 className='props-header'>Props</h3>
        <PropsTable props={props}/>
      </div>
    </div>
  )
}



const props = [
  {
    name: "label",
    required: 'true',
    description: "Instruction to be displayed on button",
    possible_values: ""
  },
  {
    name: "onClick",
    required: 'true',
    description: "Function to be launched on button click",
    possible_values: ""
  },
  {
    name: "type",
    required: 'true',
    description: "Specify the type of button to use",
    possible_values: " 'default' 'dark' 'secondary' "
  },
  {
    name: "color",
    required: 'false',
    description: "Text Color of the label",
    possible_values: "any hex or rgb value"
  },
  {
    name: "backgroundColor",
    required: 'false',
    description: "background color of the button",
    possible_values: "any hex or rgb value"
  },
  {
    name: "roundedType",
    required: 'false',
    description: " border radius type of the button",
    possible_values: " 'small' 'medium' 'large' 'extralarge' "
  },
  {
    name: "variant",
    required: 'false',
    description: " cchoose the variant of the buutton",
    possible_values: " 'filled' 'outlined' "
  },
  {
    name: "size",
    required: 'true',
    description: " which size do you want to use",
    possible_values: " 'noraml' 'large' "
  },
  {
    name: "disabled",
    required: 'true',
    description: " to disabled button",
    possible_values: "boolean"
  },
]

export default ComponentScreen(ButtonScreen)